var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"JtLineChart"}},[_c('v-chart',{ref:"chart",staticClass:"jtchart",attrs:{"option":_vm.chartSettings,"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }